<template>
  <div class="row">
    <div class="col-xl-3 col-md-3 xl-50">
      <div class="card o-hidden widget-cards" style="min-height: 175px; color: white;">
        <div class="bg-success card-body">
          <div class="media static-top-widget row">
            <div class="icons-widgets col-4">
              <div class="align-self-center text-center">
                <StoreModalAdd @ok="refreshAfterAdd"/>
              </div>
            </div>
            <div class="media-body col-8">
              <span class="m-0"></span>
              <h5 class="mb-0">
                <span class="counter">New Store</span>
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-md-3 xl-50" v-for="item in listSites">
      <div class="card o-hidden widget-cards">
        <div class="bg-warning card-body">
          <div class="media static-top-widget row">
            <div class="icons-widgets col-4">
              <div class="align-self-center text-center">
                <feather type="navigation" class="font-warning"></feather>
              </div>
            </div>
            <div class="media-body col-8">
              <span class="m-0"></span>
              <h5 class="mb-0">
                <span class="counter">{{ item.host }}</span>
              </h5>
            </div>

          </div>
          <div class="media static-top-widget row pt-4 text-center">
            <div class="icons-widgets col-12">
              <button class="btn btn-primary" @click="setStore(item.host)">ADMIN PANEL</button>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from '@/utils/firestore-shim';
import Cookies from 'js-cookie';
import StoreModalAdd from "../../pages/stores/sites/StoreModalAdd.vue";
export default {
  name: "widget",
  props: {
    target: { type: String, default: "/dashboard/site" }
  },
  data() {
    return {
      listSites: [],
    };
  },
  components: { StoreModalAdd },
  mounted() {
    this.listSites = this.getStoresData();
  },
  methods: {
    getStoresData() {
      let listSites = [];
      var ProductRef = firebase.firestore().collection("Sites")
        .get().then((e) => {
          e.forEach((doc) => {
            let element = {};
            element = doc.data();
            element.id = doc.id;
            listSites.push(element);
          });
        });
      return listSites;
    },
    refreshAfterAdd(e) {
      // Nouveau store créé : nouvelle carte immédiate + prévention de la
      // page pour rafraîchir les statistiques globales sans recharger.
      this.listSites.push(e);
      this.$emit('stores-changed');
    },
    setStore(host) {
      Cookies.set('hostCookie', host);
      this.$emit('store-selected', host);
      if (this.target) {
        this.$router.push(this.target);
      }
    }

  }
};
</script>

<style></style>